import React from "react";
import Certifpdf from "../img/saurav ranjna mooc.pdf";

const Certif = () => {
  return (
    <div style={{ height: "60rem" }}>
      {/* <iframe src={Certifpdf}></iframe> */}
      <embed
        src={Certifpdf}
        type="application/pdf"
        frameBorder="0"
        scrolling="auto"
        height="100%"
        width="100%"
      ></embed>
    </div>
  );
};

export default Certif;
